import { DEFAULT_LOCALE, DEFAULT_CURRENCY } from '@tsgecart/config';

const currencyFormatter = new Intl.NumberFormat(DEFAULT_LOCALE, {
  style: 'currency',
  currency: DEFAULT_CURRENCY,
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat(DEFAULT_LOCALE);

/**
 * Integer paise -> a formatted currency string. Division only happens
 * here, at the final display step -- every value upstream (backend DTO)
 * stays an integer paise count. Mirrors
 * `apps/web/src/features/admin/lib/format.ts` exactly (same shared
 * `DEFAULT_LOCALE`/`DEFAULT_CURRENCY` constants) so storefront and admin
 * never disagree on money formatting -- not re-exported from there since
 * the storefront must not import from `features/admin`.
 */
export function formatPaise(paise: number): string {
  return currencyFormatter.format(paise / 100);
}

export function formatCount(value: number): string {
  return numberFormatter.format(value);
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(DEFAULT_LOCALE, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(DEFAULT_LOCALE, { dateStyle: 'medium' });
}
